import { render, staticRenderFns } from "./NewContentEditor.vue?vue&type=template&id=2fcf88b7"
import script from "./NewContentEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./NewContentEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NewContentEditor.vue?vue&type=style&index=0&id=2fcf88b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports